module.exports = __webpack_public_path__ + "static/media/storage-unit.8487919d.svg";